import Layout from 'components/Layout';
import AppShell from 'components/Layout/AppShell';
import Box from 'components/UI/Box/Box';
import Tabs from 'components/UI/Tabs';
import COUPON_STATUS from 'constants/loyaltyPoints';
import { getCoupons } from 'modules/loyaltyPoints/actions';
import { useEffect, useMemo, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import useLiterals from 'utils/hooks/useLiterals';
import { useNavigate } from 'react-router-dom';
import { ROUTE_PATH } from 'routes';
import InlineError from 'components/UI/InlineError';
import Button from 'components/UI/Button';
import Coupon from './components/Coupon';

const TABS = {
  ACTIVE: COUPON_STATUS.ACTIVE,
  USED: COUPON_STATUS.USED,
  EXPIRED: COUPON_STATUS.EXPIRED,
};

const LoyaltyPointsCoupons = () => {
  const { coupons: { data: coupons, error: couponsError } } = useSelector((state) => state.loyaltyPoints);
  const literals = useLiterals('loyaltyPoints');
  const dispatch = useDispatch();
  const [tab, setTab] = useState(TABS.ACTIVE);
  const navigate = useNavigate();

  useEffect(() => {
    dispatch(getCoupons());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const list = useMemo(() => {
    return (coupons || [])?.filter((promotion) => promotion.status === tab);
  }, [coupons, tab]);

  const count = useMemo(() => {
    return {
      [TABS.ACTIVE]: (coupons || [])?.filter((promotion) => promotion.status === TABS.ACTIVE).length,
      [TABS.USED]: (coupons || [])?.filter((promotion) => promotion.status === TABS.USED).length,
      [TABS.EXPIRED]: (coupons || [])?.filter((promotion) => promotion.status === TABS.EXPIRED).length,
    };
  }, [coupons]);

  return (
    <Layout
      className='loyalty-points-coupon'
      bottomMenu
      onBack
    >
      <AppShell variant='wide'>
        <div className='flex items-center justify-between gap-2 mb-6'>
          <p className='font-bold mb-0'>
            {literals.couponHistory}
          </p>
          <p className='font-bold mb-0'>
            {`${literals.common.total}: `}
            <b>{coupons?.length ?? 0}</b>
          </p>
        </div>
        <Tabs
          tabs={[
            { value: TABS.ACTIVE, label: literals.couponsActive, count: count[TABS.ACTIVE] },
            { value: TABS.USED, label: literals.couponsUsed, count: count[TABS.USED] },
            { value: TABS.EXPIRED, label: literals.couponsExpired, count: count[TABS.EXPIRED] },
          ]}
          active={tab}
          onChange={setTab}
        />
        {couponsError ? (
          <InlineError error={literals.errorLoadCoupons} />
        ) : (
          <div className='lg:grid lg:grid-cols-2 lg:gap-x-3'>
            {list.length ? (
              list.map((coupon) => (
                <Coupon
                  key={coupon.id}
                  literals={literals}
                  coupon={coupon}
                  onClick={() => navigate(ROUTE_PATH.setLoyaltyPointsCoupon(coupon.id))}
                />
              ))
            ) : (
              <Box padding='sm'>
                <p className='text-center mt-4 mb-4'>{literals.noCoupons[tab]}</p>
              </Box>
            )}
          </div>
        )}
        <Button className='mt-6' type='secondary' to={ROUTE_PATH.LOYALTY_POINTS_PROMOTIONS}>{literals.viewPromotions}</Button>
      </AppShell>
    </Layout>
  );
};

export default LoyaltyPointsCoupons;
